import {
  VALUE_INPUT_TYPE_TEXT,
  VALUE_INPUT_TYPE_DATE,
  VALUE_INPUT_TYPE_BOOLEAN,
  VALUE_INPUT_TYPE_TEXT_AND_SEARCH,
} from 'pages/RolesAndPermissions/consts';
import * as Types from 'pages/RolesAndPermissions/typings';

function getInputType(comparison: string, fieldType: string): Types.FilterValueInputType {
  if (fieldType === 'boolean') {
    return VALUE_INPUT_TYPE_BOOLEAN;
  }

  if (fieldType === 'date') {
    return VALUE_INPUT_TYPE_DATE;
  }

  if (['is greater than', 'is less than', 'contains', 'does not contain'].includes(comparison)) {
    return VALUE_INPUT_TYPE_TEXT;
  }

  return VALUE_INPUT_TYPE_TEXT_AND_SEARCH;
}

export default getInputType;
